import { MDBCol, MDBRow } from 'mdbreact'
import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import { CheckboxToggle, Option, Picklist } from 'react-rainbow-components';
import { Link, useHistory } from 'react-router-dom';
import CustomLoader from '../shared/Customloader';
import { customStyles } from '../shared/datatables/styles';
import ShowNotification from '../shared/Notification';
import { RequestInit, RequestInitWithBody } from '../shared/RequestInit';

export interface propsToEdit {
    Id: number,
    emission: string,
    emission_Id: number,
    description: string,
    jour: string,
    heure_debut: string,
    heure_Fin: string,
    nom: string,
    active: 0 | 1,
    livecam: 0 | 1,
    planning_active: 0 | 1,
    emission_banniere: string,
    banniere_active: 0 | 1
}


const ListAllEmission = () => {
    const [emissions, setEmissions] = useState([])
    const [dropDownList, setDropDownList] = useState<[{}]>([{}])
    const [filteredData, setFilteredData] = useState([])
    const [pending, setPending] = useState(false)
    const [updated, setUpdated] = useState(false)
    const [DropdownState, setDropdownState] = useState<any>({ name: '', label: '' });
    const history = useHistory<any>();

    const subHeader = () => {
        return (
            <MDBRow className='mb-2 mt-4' center={true}>
                <MDBCol md='12' className='px-0'>
                    <Picklist
                        onChange={(value) => { setDropdownState({ name: value.name, label: value.label }) }}
                        placeholder="Choisissez l'emission"
                        name="Emissions"
                        variant='default'
                        value={DropdownState}
                        hideLabel
                        // className='mb-2'
                        enableSearch
                    >
                        <Option key={99} name={`options`} label={'Aucune'} value={'Aucune'} />
                        {dropDownList && dropDownList.map((data: any, index: number) => (
                            <Option key={index} name={index} label={data.name} value={data.Id} />
                        ))}
                    </Picklist>
                </MDBCol>
            </MDBRow>
        )
    }


    const fetchEmissions = async () => {
        await fetch('https://admin.radioemotion.be/api/emission/getallemissions', RequestInit as RequestInit)
            .then(response => response.json())
            .then(response => {
                if (response.response === true) {
                    setEmissions(response.data)
                    if (DropdownState.label === 'Aucune' || DropdownState.label === '') {
                        setFilteredData(response.data)
                    } else if (DropdownState.label !== 'Aucune' || DropdownState.label !== '') {
                        const filteredDatas = response.data.filter((item: any) => item.emission && item.emission.includes(DropdownState.label) && item.emission.length === DropdownState.label.length);
                        setFilteredData(filteredDatas)
                    }
                    setPending(false)
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    const fetchEmissionsDropdown = async () => {
        await fetch('https://admin.radioemotion.be/api/emissions/get', RequestInit as RequestInit)
            .then(response => response.json())
            .then(response => {
                if (response.response === true) {
                    setDropDownList(response.data)
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    useEffect(() => {
        setPending(true);
        fetchEmissions();
        fetchEmissionsDropdown();
        console.log(filteredData)
    }, [])

    useEffect(() => {
        console.log(DropdownState)
        if (DropdownState.label === 'Aucune' || DropdownState.label === '') {
            setFilteredData(emissions)
        } else {
            const filteredDatas = emissions.filter((item: any) => item.emission && item.emission.includes(DropdownState.label) && item.emission.length === DropdownState.label.length);
            console.log(filteredDatas)
            setFilteredData(filteredDatas)
        }
    }, [DropdownState])

    const changeActive = (Id: number, state: number, type: 'livecam' | 'isActive') => {
        const update = async () => {
            await fetch(`${type === 'isActive' ? 'https://admin.radioemotion.be/api/emission/updateactive' : 'https://admin.radioemotion.be/api/emission/updatelivecam'}`, RequestInitWithBody({ body: { Id: Id, state: state === 1 ? 0 : 1 }, type: 'POST' }) as RequestInit)
                .then(response => response.json())
                .then(response => {
                    if (response.response === true) {
                        console.log(response)
                        fetchEmissions();
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
        update();
    }

    return (
        <>
            { updated || history.location.state && history.location.state.passed === true ? <ShowNotification
                icon="check"
                iconClassName="success-dark-text"
                bodyClassName="px-5 font-weight-bold text-white success-color-dark"
                autohide={5000}
                title=""
                message={"Mise à jour réussie"}
                text="maintenant"
            /> : null}
            <MDBRow>
                <MDBCol md="9" className="offset-2" >
                    <DataTable
                        pointerOnHover={true}
                        data={filteredData}
                        noHeader={true}
                        customStyles={customStyles}
                        progressPending={pending}
                        progressComponent={<CustomLoader />}
                        subHeader={true}
                        subHeaderComponent={subHeader()}
                        pagination={true}
                        className="datatable"
                        columns={
                            [
                                {
                                    name: `Emission`,
                                    selector: `Emission`,
                                    sortable: true,
                                    width: '20%',
                                    cell: (row: propsToEdit) => <><Link to={{ pathname: `/emission/updatefullemission`, state: row }} className="font-size-0dot65vw">{row.emission}</Link></>

                                },
                                {
                                    name: `Animateur`,
                                    selector: `Nom`,
                                    sortable: true,
                                    width: '10',
                                    cell: row => <><Link to={{ pathname: `/emission/updatefullemission`, state: row }} className="font-size-0dot65vw">{row.nom}</Link></>

                                },
                                {
                                    name: `Jour`,
                                    selector: `Jour`,
                                    sortable: true,
                                    width: '10',
                                    cell: row => <><Link to={{ pathname: `/emission/updatefullemission`, state: row }} className="font-size-0dot65vw">{row.jour}</Link></>

                                },
                                {
                                    name: `debut`,
                                    selector: `Heure_debut`,
                                    sortable: true,
                                    width: '12%',
                                    cell: row => <><Link to={{ pathname: `/emission/updatefullemission`, state: row }} className="font-size-0dot65vw">{row.heure_debut}</Link></>

                                },
                                {
                                    name: `Fin`,
                                    selector: `Heure_Fin`,
                                    sortable: true,
                                    width: '12%',

                                    cell: row => <><Link to={{ pathname: `/emission/updatefullemission`, state: row }} className="font-size-0dot65vw">{row.heure_Fin}</Link></>

                                },
                                {
                                    name: `Livecam`,
                                    selector: `Livecam`,
                                    sortable: true,
                                    width: '13%',
                                    cell: row => <>
                                        <CheckboxToggle
                                            id="checkbox-toggle-component-1"
                                            label={row.livecam === 1 ? 'active' : 'pas active'}
                                            value={row.livecam === 1 ? true : false}
                                            onChange={(event: React.ChangeEvent<HTMLElement>) => changeActive(row.Id, row.livecam, 'livecam')}
                                        /></>

                                },
                                {
                                    name: 'Active',
                                    selector: 'Active',
                                    sortable: true,
                                    width: '13',
                                    cell: row => <>
                                        <CheckboxToggle
                                            id="checkbox-toggle-component-1"
                                            label={row.active === 1 ? 'active' : 'pas active'}
                                            value={row.active === 1 ? true : false}
                                            onChange={(event: React.ChangeEvent<HTMLElement>) => changeActive(row.Id, row.active, 'isActive')}
                                        /></>
                                }]}></DataTable>

                </MDBCol>
            </MDBRow>
        </>)
}

export default ListAllEmission
